"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _OptimizedContentStackImage = _interopRequireDefault(require("./components/OptimizedContentStackImage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ContentStackImage = function ContentStackImage(_ref) {
  var image = _ref.image,
      style = _ref.style,
      className = _ref.className,
      _ref$optimized = _ref.optimized,
      optimized = _ref$optimized === void 0 ? false : _ref$optimized,
      autoSizing = _ref.autoSizing,
      onLoad = _ref.onLoad,
      quality = _ref.quality;
  return optimized ? /*#__PURE__*/_react.default.createElement(_OptimizedContentStackImage.default, {
    image: image,
    style: style,
    autoSizing: autoSizing,
    onLoad: onLoad,
    quality: quality
  }) : /*#__PURE__*/_react.default.createElement("img", {
    onLoad: onLoad,
    style: style,
    src: image.url,
    className: className,
    alt: image.title || " "
  });
};

var _default = ContentStackImage;
exports.default = _default;